/**
 * @freesewing/plugin-measurements | v2.17.1
 * A FreeSewing plugin that adds additional measurements that can be calculated from existing ones
 * (c) 2021 Joost De Cock <joost@joost.at> (https://github.com/joostdecock)
 * @license MIT
 */
var name = "@freesewing/plugin-measurements";
var version = "2.17.1";

var index = {
  name: name,
  version: version,
  hooks: {
    preDraft: function ({ settings }) {
      if (
        typeof settings.measurements.seatBack !== 'undefined' &&
        typeof settings.measurements.seat !== 'undefined'
      ) {
        settings.measurements.seatFront =
          settings.measurements.seat - settings.measurements.seatBack;
        settings.measurements.seatBackArc = settings.measurements.seatBack / 2;
        settings.measurements.seatFrontArc = settings.measurements.seatFront / 2;
      }
      if (
        typeof settings.measurements.waist !== 'undefined' &&
        typeof settings.measurements.waistBack !== 'undefined'
      ) {
        settings.measurements.waistBackArc = settings.measurements.waistBack / 2;
        settings.measurements.waistFrontArc =
          (settings.measurements.waist - settings.measurements.waistBack) / 2;
      }
      if (
        typeof settings.measurements.crossSeam !== 'undefined' &&
        typeof settings.measurements.crossSeamFront !== 'undefined'
      ) {
        settings.measurements.crossSeamBack =
          settings.measurements.crossSeam - settings.measurements.crossSeamFront;
      }
    },
  },
};

export default index;
//# sourceMappingURL=index.mjs.map
